import React from 'react';
import logo from '../../commingSoon/assets/logo_prime.webp';
import backgroundImage from '../../commingSoon/assets/image.png';
import '../../commingSoon/App.css';
import Footer from 'src/commingSoon/components/Footer';

const ComingSoon: React.FC = () => {
  return (
    <div className="coming-soon-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="content-wrapper">
        <div className="header-section">
          <img src={logo} alt="Prime Telehealth" className="logo" />
          <p className="subtitle">Connecting Patients with Healthcare Professionals</p>
        </div>

        <div className="main-content">
          <div className="progress-container">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
          <div className="coming-soon-badge">
            <span>Coming Soon</span>
          </div>
          <div className="description">
            <p>
              We're building a revolutionary telehealth platform that will transform how patients connect with
              healthcare professionals. Get ready for seamless consultations, appointment scheduling, and
              comprehensive healthcare management.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🩺</div>
              <h3>Virtual Consultations</h3>
              <p>Connect with doctors from anywhere, anytime</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Easy Scheduling</h3>
              <p>Book appointments with just a few clicks</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure & Private</h3>
              <p>Your health data is protected and secure</p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ComingSoon;
